// src/Components/Forms/Financement/Salam/Paiement/Tab2.tsx
import React from 'react';
import { Box } from '@mui/material';
import { Spin } from 'antd';
import Table from '../../../../TableResizable';
import { ColumnsType } from 'antd/es/table';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';

interface Tab2Props {
  data: any[];
}

const Tab2: React.FC<Tab2Props> = ({ data }) => {
  const columns: ColumnsType<any> = [
    { title: 'Date Paiement', dataIndex: 'DatePaiement' },
    { title: 'ID Paiement', dataIndex: 'PaiementID' },
    { title: 'Montant Payé', dataIndex: 'MontantPaye', render: (v) => formatNumber(v) },
    { title: 'Compte Source', dataIndex: 'CompteSource' },
    { title: 'Compte Destination', dataIndex: 'CompteDestination' },
    { title: 'Référence Opération', dataIndex: 'ReferenceOperation' },
    { title: 'Raison', dataIndex: 'Observation' },
    { title: 'Utilisateur', dataIndex: 'CreePar' },
  ];

  return (
    <div className="tabItem">
      <Box fontStyle="inherit" className="border" height="60%" width="85%" position="absolute">
        <Spin spinning={false}>
          <Table
            size="small"
            style={{ width: '100%' }}
            columns={columns}
            dataSource={data}
            scroll={{ y: 250, x: 10 }}
            pagination={false}
            rowKey="PaiementID"
          />
        </Spin>
      </Box>
    </div>
  );
};

export default Tab2;